export default "__VITE_ASSET__B3r9xJzV__"